export default __webpack_public_path__ + "static/media/delete.9f5b5abc.svg";